const common: Record<string, string> = {
  "nav.home": "首页",
  "nav.category": "分类",
  "nav.about": "关于我们",
  "nav.contact": "联系我们",
  "site.name": "韩影精选",
  "site.subtitle": "韩国伦理电影深度解析与推荐",
  "site.description": "精选韩国伦理片高分榜单，涵盖经典与最新韩国伦理电影推荐，深度解析剧情、演员与导演风格",
  "hero.title": "探索韩国伦理电影的艺术边界",
  "hero.subtitle": "从禁忌之恋到社会批判，每一帧都是对人性的深度凝视",
  "hero.cta": "开始探索",
  "section.featured": "精选推荐",
  "section.ranking": "高分榜单",
  "section.latest": "最新文章",
  "section.faq": "常见问题",
  "section.related": "相关推荐",
  "category.all": "全部",
  "category.forbidden_love": "禁忌爱情",
  "category.social_critique": "社会批判",
  "category.thriller": "悬疑惊悚",
  "category.classic": "经典回顾",
  "category.latest_release": "最新上映",
  "article.read_more": "阅读全文",
  "article.director": "导演",
  "article.cast": "主演",
  "article.year": "年份",
  "article.rating": "评分",
  "article.genre": "类型",
  "article.runtime": "片长",
  "breadcrumb.home": "首页",
  "footer.copyright": "© 2024 韩影精选. 保留所有权利.",
  "footer.disclaimer": "本站内容仅供影迷交流与学术研究，不提供任何影片下载或在线播放服务。",
  "about.title": "关于韩影精选",
  "about.brand_intro": "品牌介绍",
  "about.reputation": "口碑评价",
  "about.contact": "联系我们",
  "about.contact_desc": "有任何建议或合作意向，欢迎通过以下表单与我们联系",
  "form.name": "姓名",
  "form.email": "邮箱",
  "form.message": "留言内容",
  "form.submit": "发送消息",
  "form.success": "消息已成功发送，我们会尽快回复您！",
  "form.error": "发送失败，请稍后重试。",
  "form.sending": "发送中...",
  "rating.score": "分",
  "scroll_top": "回到顶部",
  "load_more": "加载更多",
};

export default common;